import { useTranslation } from "react-i18next";

function Testimonials() {
  const { t } = useTranslation();

  const testimonials = [
    {
      id: 1,
      name: t("testimonialOneName"),
      role: t("testimonialOneRole"),
      company: t("testimonialOneCompany"),
      logo: "/images/fairjob-logo.png",
    },
    {
      id: 2,
      name: t("testimonialTwoName"),
      role: t("testimonialTwoRole"),
      company: t("testimonialTwoCompany"),
      logo: "/images/lapea.webp",
    },
    {
      id: 3,
      name: t("testimonialThreeName"),
      role: t("testimonialThreeRole"),
      company: t("testimonialThreeCompany"),
      logo: "/images/externwork.avif",
    },
        {
      id: 4,
      name: t("testimonialThreeName"),
      role: t("testimonialThreeRole"),
      company: t("testimonialThreeCompany"),
      logo: "/images/peanutpersonal.png",
    },
        {
      id: 5,
      name: t("testimonialThreeName"),
      role: t("testimonialThreeRole"),
      company: t("testimonialThreeCompany"),
      logo: "/images/MatchingCompany.png",
    },
        {
      id: 6,
      name: t("testimonialThreeName"),
      role: t("testimonialThreeRole"),
      company: t("testimonialThreeCompany"),
      logo: "/images/FlexPeople.png",
    },
  ];

  // Wir vervielfältigen die Logos, damit der Loop auch auf breiten Bildschirmen lückenlos läuft
  const marqueeLogos = [...testimonials, ...testimonials, ...testimonials, ...testimonials];

  return (
    <div className="w-full py-12 md:py-20 bg-white overflow-hidden relative">
      
      {/* Lokaler CSS-Style für die performante Endlos-Schleife */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          display: flex;
          width: max-content;
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}} />

      <div className="project-container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold mb-3">
            {t("testimonialsHeading")}
          </h2>
          <p className="text-base md:text-lg text-[#A6A6A6] max-w-2xl mx-auto">
            {t("testimonialsSubheading")}
          </p>
        </div>
      </div>

      {/* Das Karussell-Band */}
      <div className="relative w-full flex overflow-x-hidden py-6 border-y border-gray-100 bg-gray-50/30">
        
        {/* 1. Fading Edges (Sanftes Ausblenden an den Rändern) */}
        <div className="absolute inset-y-0 left-0 w-16 md:w-40 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-16 md:w-40 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        {/* 2. Die animierte Logo-Strasse */}
        <div className="animate-marquee flex gap-16 md:gap-24 items-center">
          {marqueeLogos.map((item, index) => (
            <div
              key={`${item.id}-${index}`}
              className="flex items-center justify-center shrink-0 w-[130px] md:w-[160px] h-12 grayscale opacity-40 hover:grayscale-0 hover:opacity-100 transition-all duration-300 ease-in-out cursor-pointer"
            >
              <img
                src={item.logo}
                alt={item.company ? `${item.company} Logo` : "Partner Logo"}
                className="max-h-10 max-w-full object-contain"
              />
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Testimonials;